export const ACTIONS = {
    SET_LOADING: 'SET_LOADING',
    SET_ERROR: 'SET_ERROR',
    SET_ACQUITTALS: 'SET_ACQUITTALS',
    SET_SELECTED_ACQUITTAL: 'SET_SELECTED_ACQUITTAL',
    ADD_ACQUITTAL: 'ADD_ACQUITTAL',
    UPDATE_ACQUITTAL: 'UPDATE_ACQUITTAL',
    DELETE_ACQUITTAL: 'DELETE_ACQUITTAL',
    CLEAR_ERROR: 'CLEAR_ERROR',
    SET_PENDING_ACQUITTALS: 'SET_PENDING_ACQUITTALS',
    SET_ACQUITTAL_TIMELINE: 'SET_ACQUITTAL_TIMELINE'
};

export const initialState = {
    acquittals: [],
    selectedAcquittal: null,
    loading: false,
    error: null,
    pendingAcquittals: [],
    timeline: []
};

export const acquittalsReducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.SET_LOADING:
            return { ...state, loading: action.payload };
        case ACTIONS.SET_ERROR:
            return { ...state, error: action.payload };
        case ACTIONS.SET_ACQUITTALS:
            return { ...state, acquittals: action.payload };
        case ACTIONS.SET_PENDING_ACQUITTALS:
            return { ...state, pendingAcquittals: action.payload };
        case ACTIONS.SET_SELECTED_ACQUITTAL:
            return { ...state, selectedAcquittal: action.payload };
        case ACTIONS.ADD_ACQUITTAL:
            return { ...state, acquittals: [...state.acquittals, action.payload] };
        case ACTIONS.UPDATE_ACQUITTAL:
            return {
                ...state,
                acquittals: state.acquittals.map((acq) => (acq.id === action.payload.id ? action.payload.data : acq))
            };
        case ACTIONS.DELETE_ACQUITTAL:
            return {
                ...state,
                acquittals: state.acquittals.filter((acq) => acq.id !== action.payload)
            };
        case ACTIONS.CLEAR_ERROR:
            return { ...state, error: null };
        case ACTIONS.SET_ACQUITTAL_TIMELINE:
            return {
                ...state,
                timeline: action.payload,
                loading: false,
                error: null
            };

        default:
            return state;
    }
};
